import type { EntradasDoMes } from "@base/contracts";

export type TipoDeEntrada = "moeda" | "porcentagem";

export const TIPO_DA_ENTRADA: Readonly<Record<keyof EntradasDoMes, TipoDeEntrada>> = {
  orcamentoCentavos: "moeda",
  cplCentavos: "moeda",
  taxaMql: "porcentagem",
  taxaAgendamento: "porcentagem",
  taxaConsulta: "porcentagem",
  taxaVenda: "porcentagem",
  ticketMedioCentavos: "moeda",
  faturamentoClinicaCentavos: "moeda",
};

const numeroBr = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 });

/** Valor guardado -> texto do campo: "3.000,5" para dinheiro, "12,5" para 12,5%. */
export function formatarEntrada(tipo: TipoDeEntrada, valor: number): string {
  if (valor === 0) return "";
  return numeroBr.format(tipo === "moeda" ? valor / 100 : valor * 100);
}

/**
 * Texto digitado -> valor guardado. Aceita "3000", "3.000,50", "R$ 3.000" e,
 * em porcentagem, "12", "12,5" ou "12%". Vazio vira 0 ("nao definido").
 * `null` quando nao da para entender (o campo mostra o erro).
 */
export function lerEntrada(tipo: TipoDeEntrada, texto: string): number | null {
  const limpo = texto.replace(/R\$|%|\s/g, "");
  if (limpo === "") return 0;
  // Ponto so e decimal quando nao ha virgula e ele separa ate 2 casas no fim.
  const normalizado = limpo.includes(",")
    ? limpo.replace(/\./g, "").replace(",", ".")
    : /^\d+\.\d{1,2}$/.test(limpo)
      ? limpo
      : limpo.replace(/\./g, "");
  if (!/^\d+(\.\d+)?$/.test(normalizado)) return null;
  const numero = Number(normalizado);
  if (tipo === "moeda") return Math.round(numero * 100);
  if (numero > 100) return null;
  return Math.round(numero * 100) / 10_000;
}
